import React, { useState } from 'react'
import './Testimonials.scss'
import TestimonialsSlider from './TestimonialsSlider/TestimonialsSlider'

import testimonials1 from '../../../assets/images/testimonials1.png'
import testimonials2 from '../../../assets/images/testimonials2.png'
import testimonials3 from '../../../assets/images/testimonials3.png'

const Testimonials = () => {
    const [activeSlide, setActiveSlide] = useState(1);
    const testimonialData = [
        { imgSrc: testimonials1, text: 'Charlotte Ava', para: 'Maecenas vel eros ac dolor ultricies faucibus ut ut ante. Aenean id tortor nisi. Mauris eleifend risus leo, sit amet interdum velit imperdiet laoreet. Duis vestibulum lectus ex, eu venenatis velit tempus ut. In congue maximus sapien, id euismod turpis congue eget.' },
        { imgSrc: testimonials2, text: 'David Richard', para: 'Luisacx vel eros ac dolor ultricies faucibus ut ut ante. Aenean id tortor nisi. Mauris eleifend risus leo, sit amet interdum velit imperdiet laoreet. Duis vestibulum lectus ex, eu venenatis velit tempus ut. In congue maximus sapien, id euismod turpis congue eget.' },
        { imgSrc: testimonials3, text: 'James Robert', para: 'Ginneee vel eros ac dolor ultricies faucibus ut ut ante. Aenean id tortor nisi. Mauris eleifend risus leo, sit amet interdum velit imperdiet laoreet. Duis vestibulum lectus ex, eu venenatis velit tempus ut. In congue maximus sapien, id euismod turpis congue eget.' },
    ];

    return (
        <div className='Testimonials-main-container'>
            <div className='Testimonials-container'>
                <h3>Testimonials</h3>
                <h5 className='pt-2'>What our customers say about us</h5>
                <TestimonialsSlider
                    slides={testimonialData}
                    activeSlide={activeSlide}
                    onSlideChange={setActiveSlide}
                />
            </div>
        </div>
    )
}

export default Testimonials